import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=8e8d2dba&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e8d2dba')) {
      api.createRecord('8e8d2dba', component.options)
    } else {
      api.reload('8e8d2dba', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=8e8d2dba&", function () {
      api.rerender('8e8d2dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29WWMpi3zCEAy/JS/offershelp.vue"
export default component.exports